enum QaAssetType {
  PHOTO = "aad9fb96-de04-44a6-a89e-23c7119dba9d",
  VIDEO = "0bd47f90-a19e-433b-b723-1675a1f1e0d8",
}

export default QaAssetType;
